import { referenceContentNodeOperationType } from './content-node-reference';
import { fallbackOperationType } from './fallback';
import { filterListOperationType } from './filter-list';
import { filterListContentNodeOperationType } from './filter-list-content-node';
import { generateUrlStorageOperationType } from './generate-url-storage';
import { joinListAsTextOperationType } from './join-list-as-text';
import { listToStringOperationType } from './list-to-string';
import { nullContentNodeReferenceOperationType } from './null-content-node-reference';
import { queryVariableReferenceOperationType } from './query-variable-reference';
import { referenceSelectorOperationType } from './reference-selector';
import { setStateOperationType } from './set-state';
import { stringBuilderOperationType } from './string-builder';
import { referenceThisContentNodeOperationType } from './this-content-node-reference';
export const runtimeOperationTypes = {
    [stringBuilderOperationType.kind]: stringBuilderOperationType,
    [referenceSelectorOperationType.kind]: referenceSelectorOperationType,
    [fallbackOperationType.kind]: fallbackOperationType,
    [referenceContentNodeOperationType.kind]: referenceContentNodeOperationType,
    [referenceThisContentNodeOperationType.kind]: referenceThisContentNodeOperationType,
    [joinListAsTextOperationType.kind]: joinListAsTextOperationType,
    [filterListOperationType.kind]: filterListOperationType,
    [filterListContentNodeOperationType.kind]: filterListContentNodeOperationType,
    [nullContentNodeReferenceOperationType.kind]: nullContentNodeReferenceOperationType,
    [generateUrlStorageOperationType.kind]: generateUrlStorageOperationType,
    [setStateOperationType.kind]: setStateOperationType,
    [listToStringOperationType.kind]: listToStringOperationType,
    [queryVariableReferenceOperationType.kind]: queryVariableReferenceOperationType,
};
export { isRuntimeOperationConfig } from './common';
//# sourceMappingURL=index.js.map